import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function ChangeLogIndividualListComponent(props) {
  let displayLines = [
    <Typography key="default" sx={{ backgroundColor: "white" }}>
      No changes found
    </Typography>,
  ];
  if (props.changeLog) {
    const changeLines = props.changeLog.split("||");
    changeLines.sort(
      (a, b) =>
        parseInt(b.substring(0, b.indexOf("|"))) -
        parseInt(a.substring(0, a.indexOf("|"))),
    );

    displayLines = changeLines.map((line, index) => {
      /*const changeDateTime = new Date(
        parseInt(line.substring(0, line.indexOf("|"))),
      );*/
      let changeInfo = line.substring(line.indexOf("|") + 1);
      changeInfo = changeInfo.replace(":c:", " changed ");
      if (changeInfo.indexOf(":t:") >= 0) {
        changeInfo = changeInfo.replace(":f:", " from ");
        changeInfo = changeInfo.replace(":t:", " to ");
      } else {
        changeInfo = changeInfo.replace(":f:", " ");
      }
      changeInfo = changeInfo.replace(":o:", " on ");
      let bgColor = "gainsboro";
      if (index % 2 == 0) {
        bgColor = "white";
      }
      const formattedLine = (
        <Typography key={index} sx={{ backgroundColor: bgColor }}>
          {changeInfo}
        </Typography>
      );
      return formattedLine;
    });
  }
  return (
    <Box
      sx={{
        border: "solid 1px",
        height: "300px",
        textAlign: "left",
        overflowY: "scroll",
      }}
    >
      {displayLines}
    </Box>
  );
}

export default ChangeLogIndividualListComponent;

ChangeLogIndividualListComponent.propTypes = {
  changeLog: PropTypes.string,
};
